// extracted by mini-css-extract-plugin
module.exports = {"tablepd":"index_tablepd_2fOSi","locked":"index_locked_3SAxv"};